import { Injectable } from '@angular/core';
import { BaseStoreRepository } from '../base-store.repository';
import { passingModeInitialState, PassingModeStateProps, passingModeStateStore } from './passing-mode-state.store';
import { select } from '@ngneat/elf';

@Injectable({
  providedIn: 'root',
})
export class PassingModeRepository extends BaseStoreRepository<PassingModeStateProps> {
  constructor() {
    super(passingModeStateStore.pipe(select(state => state)), passingModeStateStore, passingModeInitialState);
  }
}
